

import { useState } from "react";
import { useEffect, useRef } from "react";

import { useSelector, useDispatch } from 'react-redux';

const PropertyDescriptions = () => {
  const [click, setClick] = useState(true);
  const handleClick = () => setClick(!click);
  const pdpInitData = useSelector(state => state.pdp?.pdpInitData);


  const [expanded, setExpanded] = useState(false);
  const [showToggle, setShowToggle] = useState(false);
  const contentRef = useRef(null);


  const { propertyId, detailedAttributes, commonAttributes } =
    pdpInitData?.propertyDetails;


  const { propCategory } = commonAttributes;

  const shortDescription = pdpInitData?.propertyDetails?.shortDescription;

  const marketDescription = pdpInitData?.propertyDetails?.marketingDescription;


  const formattedtTxt = marketDescription?.split(/\r?\n/).map((line, index) => (
    <p className='pdpBody3' key={index}>{line}</p>
  ));


  // useEffect(() => {
  //   if (contentRef.current) {
  //     const lineHeight = parseFloat(getComputedStyle(contentRef.current).lineHeight);
  //     const maxLines = 4;
  //     const maxHeight = lineHeight * maxLines;
  //     if (contentRef.current.scrollHeight > maxHeight) {
  //       setShowToggle(true);
  //     }
  //   }
  // }, [pdpInitData?.propertyDetails?.detailedAttributes.description ]);


  return (
    <>
      <p className="mb25 pdpTextBlack" tabIndex="0">
        {
          propCategory === 'COMMERCIAL' ?

        // <div dangerouslySetInnerHTML={{ __html: formattedtTxt}}></div>


            <>
            {/* <p className="pdpSubtitle2" tabIndex="0">{shortDescription}</p> */}
            <div dangerouslySetInnerHTML={{ __html: pdpInitData?.propertyDetails?.shortDescription}}></div>


            
            
            <div dangerouslySetInnerHTML={{ __html: pdpInitData?.propertyDetails?.marketingDescription }}></div>

            {/* <p tabIndex="0">{formattedtTxt}</p>
            
            </> */}
            </>


            :


            // <div className="html-text-container">
            //   <div
            //     className={`html-text ${expanded ? 'expanded' : 'collapsed'}`}
            //     ref={contentRef}
            //     dangerouslySetInnerHTML={{ __html: pdpInitData?.propertyDetails?.detailedAttributes.description }}
            //   />
            //   {showToggle && (
            //     <button className="toggle-button" onClick={() => setExpanded(!expanded)}>
            //       {expanded ? 'Show Less' : 'Show More'}
            //     </button>
            //   )}
            // </div>

          <div dangerouslySetInnerHTML={{ __html: pdpInitData?.propertyDetails?.detailedAttributes.description }}></div>

        }
        {/* {pdpInitData?.propertyDetails?.detailedAttributes.description}  */}
      </p>

    </>
  );
};

export default PropertyDescriptions;
